var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginCheckDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check_circle_white_48dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14975",
    "data-name": "Path 14975",
    d: "M0,0H35V35H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14976",
    "data-name": "Path 14976",
    d: "M17.5,4A13.5,13.5,0,1,0,31,17.5,13.518,13.518,0,0,0,17.5,4ZM14.125,25.938l-6.75-6.75,2.379-2.379,4.371,4.354L25.246,10.041l2.379,2.4Z",
    transform: "translate(0 0)",
    fill: "#d6d6d6",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14977",
    "data-name": "Path 14977",
    d: "M17.5,2A15.5,15.5,0,1,0,33,17.5,15.506,15.506,0,0,0,17.5,2Zm0,27.9A12.4,12.4,0,1,1,29.9,17.5,12.416,12.416,0,0,1,17.5,29.9Zm7.114-19.251L14.4,20.863l-4.014-4L8.2,19.05l6.2,6.2,12.4-12.4Z",
    transform: "translate(0 0)",
    fill: "#d6d6d6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginCheckDisabled);
export default __webpack_public_path__ + "static/media/login-check-disabled.68e8b0e13f49bd01dbfbd9e5e694c64b.svg";
export { ForwardRef as ReactComponent };